import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container" style={{ padding: '24px 0', paddingLeft: '12px', paddingRight: '12px', display: 'grid', gap: 16 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 16 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <img src="/rokaicon-r.png" alt="Usine Sousse" width="40" height="40" />
              <div>
                <strong>Roka TC</strong>
                <div style={{ fontSize: 12 }}>Fabrication Tunisienne</div>
              </div>
            </div>
            <p style={{ color: '#475569' }}>Usine basée à Sousse, main-d'œuvre tunisienne. Spécialistes des volumes et de la qualité.</p>
          </div>
          <div>
            <strong>Liens</strong>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/produits">Produits</Link></li>
              <li><Link to="/a-propos">À propos</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div>
            <strong>Contact</strong>
            <ul style={{ listStyle: 'none', padding: 0, margin: 8 }}>
              <li>Téléphone <img src="/assets/tn-flag.svg" alt="TN Flag" style={{ height: '1em', verticalAlign: 'middle' }} />
                &nbsp; : +216 94 94 99 02</li>
              <li>Téléphone <img src="/assets/fr-flag.svg" alt="FR Flag" style={{ height: '1em', verticalAlign: 'middle' }} />
                &nbsp; : +33 6 05 00 10 13</li>
              <li>Email : contact@rokatc.com</li>
              <li>Adresse : Sousse, Tunisie</li>
            </ul>
          </div>
        </div>
        <div style={{ fontSize: 12, color: '#64748b' }}>© {new Date().getFullYear()} Roka TC — Tous droits réservés.</div>
      </div>
    </footer>
  );
};

export default Footer;
